import { render } from "./TopNavigation.vue?vue&type=template&id=704ade97&ts=true&lang=pug"
import script from "./TopNavigation.vue?vue&type=script&lang=ts"
export * from "./TopNavigation.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__